import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/orpc/client';
import { buildPublicAllocatorRows, type PublicAllocatorMarketKey, type PublicAllocatorRowState } from './publicAllocator';
export function usePublicAllocatorSettings(t0) {
  const $ = _c(17);
  const {
    chainId,
    vaultAddress,
    markets
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== vaultAddress) {
    t1 = orpc.vaultV2.publicAllocatorSettings.queryOptions({
      input: {
        chainId,
        address: vaultAddress
      },
      staleTime: 60000
    });
    $[0] = chainId;
    $[1] = vaultAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t1);
  const data = query.data;
  const status = query.isPending ? "loading" : "error";
  let t2;
  if ($[3] !== data || $[4] !== markets || $[5] !== status) {
    t2 = data ? buildPublicAllocatorRows(markets, data) : new Map(markets.map(market => [`${market.marketId}:${market.adapter.toLowerCase()}`, {
      status
    } satisfies PublicAllocatorRowState]));
    $[3] = data;
    $[4] = markets;
    $[5] = status;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const rows = t2;
  const t3 = data?.publicAllocator === null;
  const t4 = data?.isAllocator ?? false;
  const t5 = data?.canPullFromIdle ?? null;
  let t6;
  if ($[7] !== data) {
    t6 = data ? BigInt(data.penaltyWad) : null;
    $[7] = data;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== query.isError || $[10] !== query.isPending || $[11] !== rows || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = {
      rows,
      isLoading: query.isPending,
      isError: query.isError,
      isUnsupported: t3,
      isSetUp: t4,
      canPullFromIdle: t5,
      penaltyWad: t6
    };
    $[9] = query.isError;
    $[10] = query.isPending;
    $[11] = rows;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}